import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { type ReactNode, useId } from 'react';
import { chipListSx } from './OpenXAgentTitledCard.styles.ts';
import { cardSx } from './utils/styles.ts';

type OpenXAgentTitledCardProps = {
  title: string;
  action?: ReactNode;
  children: ReactNode;
};

export const OpenXAgentTitledCard = ({ title, action, children }: OpenXAgentTitledCardProps) => {
  const titleId = useId();

  return (
    <Box component="section" aria-labelledby={titleId} sx={{ ...cardSx, p: '15px 23px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 28 }}>
        <Typography id={titleId} variant="h2" component="h3" sx={{ m: 0, color: 'text.primary' }}>
          {title}
        </Typography>

        {action}
      </Box>

      {children}
    </Box>
  );
};

export const OpenXAgentChipList = ({ children }: { children: ReactNode }) => (
  <Box component="ul" sx={chipListSx}>
    {children}
  </Box>
);
